const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/location/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import i18n from '@/lib/translations/i18n';
import { compactBooleanFilterSchema, compactPicklistFilterSchema } from '@/lib/zod-schemas/common/compactFilterSchemas';
const locationSearchSchema = z.object({
  holidaySchemeId: compactPicklistFilterSchema,
  showArchivedLocations: compactBooleanFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/settings/location/')({
  validateSearch: zodValidator(locationSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ({
    context: {
      flags
    }
  }) => {
    if (!flags.capacityLocations) {
      throw notFound();
    }
  },
  loader: (): LoaderData => ({
    crumb: i18n.t('common.settings.location.location')
  }),
  staticData: {
    topNav: {
      title: i18n.t('common.settings.location.location')
    }
  }
});